<template>
    <div @mouseover="onMouseOver" @mousedown="onMouseOver">
		<input type="checkbox" :id="id"
			:readonly="readonly"
			@change="onChange"
			v-model="iValue">
		<label :for="id" :disabled="readonly" :class="{'indeterminate': isIndeterminated}" @click="onClick">{{text}}</label>
		</div>
</template>

<script>

import GUID from '../mixins/GUIDMixin';

export default {
	name: 'CCheckbox',
	mixins: [GUID],
	props: {
		value: {
			type: Boolean,
			required: false,
		},
		indeterminate: {
			type: Boolean,
			required: false,
			default: false,
		},
		text: {
			type: String,
			required: false,
		},
		readonly: {
			type: Boolean,
			required: false,
			default: false,
		},
		checkOnClickedMousover: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	data() {
		return {
			iValue: this.value,
			id: this.getChkBoxId(),
		};
	},
	watch: {
		value() {
			this.iValue = this.value;
		},
	},
	mounted() {
	},
	computed: {
		isIndeterminated() {
			return this.iValue && this.indeterminate;
		},
	},
	methods: {
		onClick(e) {
			if (this.checkOnClickedMousover) {
				e.preventDefault();
				e.stopPropagation();
			}
		},
		onChange() {
			this.$emit('input', this.iValue);
			this.$emit('change', this.iValue);
		},
		onMouseOver(e) {
			if (e.buttons == 1 && this.checkOnClickedMousover) {
				this.iValue = !this.iValue;
				this.onChange();
			}
		},
		getChkBoxId() {
			return `chkBx${this.createGuid()}`;
		},
	},
};
</script>

<style>
	input[type="checkbox"] {
		display:none;
	}
	input[type="checkbox"][readonly] + label {
		pointer-events: none;
	}
	input[type="checkbox"] + label::before {
		width: 15px;
		height: 15px;
		border-radius: 2px;
		border: 2px solid #1867c0;
		background-color: #fff;
		display: block;
		content: "";
		float: left;
		margin-right: 5px;
		margin-top:3px;
	}
	input[type="checkbox"]:checked+label::before {
		box-shadow: inset 0px 0px 0px 3px #fff;
		background-color: #1867c0;
	}

	input[type="checkbox"]:hover + label::before {
		background-color: #ccc;
		cursor: pointer;
	}

	.indeterminate::before {
		box-shadow: inset 0px 0px 0px 4px #fff!important;
	}
</style>
